export default __webpack_public_path__ + "static/media/skeleton1.d3fbb614.png";